import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fraud-dashboard',
  templateUrl: './fraud-dashboard.component.html',
  styleUrls: ['./fraud-dashboard.component.css']
})
export class FraudDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
